<template>
  <div class="txn-page twod-home">
    <div class="txn-inner twod-home__inner">
      <section class="txn-card" aria-label="2D">
        <h1 class="txn-title">
          {{
            $store.state.language === 'en'
              ? '2D'
              : 'နှစ်လုံး'
          }}
        </h1>
        <div class="txn-body twod-home__quick">
          <button
            type="button"
            class="twod-quick"
            disabled
          >
            <img
              src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/29b18ae7-d373-44f2-84e6-ea9afc6f7700/public"
              alt=""
              class="twod-quick__icon"
            >
            <span class="twod-quick__label">{{
              $store.state.language === 'en' ? 'Records' : 'မှတ်တမ်း'
            }}</span>
          </button>
          <button
            type="button"
            class="twod-quick"
            @click="$router.push('/user/2d/closed')"
          >
            <img
              src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/f2c383ee-9527-4e01-d4e9-d2469194ee00/public"
              alt=""
              class="twod-quick__icon"
            >
            <span class="twod-quick__label">{{
              $store.state.language === 'en' ? 'Closed days' : 'ပိတ်ရက်များ'
            }}</span>
          </button>
          <button
            type="button"
            class="twod-quick"
            @click="$router.push('/user/2d/winner')"
          >
            <img
              src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/e2a839c7-ad51-4dd4-afcb-38189ef1fd00/public"
              alt=""
              class="twod-quick__icon"
            >
            <span class="twod-quick__label">{{
              $store.state.language === 'en' ? 'Winners' : 'အနိုင်ရစာရင်း'
            }}</span>
          </button>
        </div>
      </section>

      <section
        class="txn-card twod-home__result-card"
        :aria-label="$store.state.language === 'en' ? 'Result' : 'ရလဒ်'"
      >
        <h2 class="txn-section-title">
          {{
            isLive
              ? ($store.state.language === 'en' ? 'Live result' : 'တိုက်ရိုက်ရလဒ်')
              : ($store.state.language === 'en' ? 'Latest result' : 'နောက်ဆုံးရလဒ်')
          }}
        </h2>
        <div class="txn-body twod-home__result-body">
          <template v-if="isLive">
            <div class="twod-live-wrap">
              <div class="twod-live-number">
                {{ twoDdata.live }}
              </div>
              <div class="twod-live-meta">
                <div class="twod-live-meta__item">
                  <span class="twod-live-meta__k">{{
                    $store.state.language === 'en' ? 'Set' : 'စက်'
                  }}</span>
                  <span class="twod-live-meta__v">{{ twoDdata.live_set }}</span>
                </div>
                <div class="twod-live-meta__item">
                  <span class="twod-live-meta__k">{{
                    $store.state.language === 'en' ? 'Value' : 'တန်ဖိုး'
                  }}</span>
                  <span class="twod-live-meta__v">{{ twoDdata.live_val }}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="twod-last-grid">
              <div class="twod-last-grid__num">
                <span v-if="twoDHistories.length > 0">{{ lastNumber }}</span>
                <span v-else class="twod-last-grid__placeholder">—</span>
              </div>
              <div class="twod-last-grid__info">
                <p class="twod-last-grid__hint">
                  {{
                    $store.state.language === 'en'
                      ? 'Last draw time'
                      : 'နောက်ဆုံး အပ်ဒိတ်'
                  }}
                </p>
                <p class="twod-last-grid__time">{{ lastUpdatedDraw }}</p>
                <p class="twod-last-grid__date">{{ lastUpdatedDate }}</p>
              </div>
            </div>
          </template>
        </div>
      </section>

      <section class="txn-card twod-home__history" aria-label="History">
        <h2 class="txn-section-title">
          {{
            $store.state.language === 'en' ? 'Draw history' : 'ထီဖွင့်ချိန်မှတ်တမ်း'
          }}
        </h2>
        <div class="txn-body twod-home__table-wrap">
          <table class="twod-history-table">
            <thead>
              <tr>
                <th>{{ $store.state.language === 'en' ? 'Date' : 'နေ့စွဲ' }}</th>
                <th>{{ $store.state.language === 'en' ? '12:01' : 'မနက် ၁၂:၀၁' }}</th>
                <th>{{ $store.state.language === 'en' ? '4:30 PM' : 'ညနေ ၄:၃၀' }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(twodHistory, index) in twoDHistories"
                :key="index"
              >
                <td>{{ twodHistory.draw_date }}</td>
                <td>{{ twodHistory.morning_result }}</td>
                <td>{{ twodHistory.evening_result }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div class="twod-home__bet-bar">
      <button
        type="button"
        class="txn-submit twod-home__bet-btn"
        @click="toGoToTwodPage()"
      >
        {{
          $store.state.language === 'en'
            ? 'Place bet'
            : 'ထိုးမည်'
        }}
      </button>
    </div>

    <div
      class="modal fade"
      id="timeLimitModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="timeLimitModalLabel"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content twod-home-modal">
          <div class="modal-body twod-home-modal__body">
            <p
              id="timeLimitModalLabel"
              class="twod-home-modal__title"
            >
              {{
                $store.state.language === 'en'
                  ? 'Choose draw'
                  : 'ထီဖွင့်ချိန် ရွေးပါ'
              }}
            </p>
            <template v-if="!noticeText">
              <button
                v-for="(option, index) in twodOptions"
                :key="index"
                type="button"
                class="twod-draw-option"
                :class="{ 'twod-draw-option--active': draw === option.data }"
                @click="draw = option.data"
              >
                {{ option.label }}
              </button>
            </template>
            <p
              v-else
              class="twod-home-modal__notice"
            >
              {{ noticeText }}
            </p>
            <button
              v-if="!noticeText"
              type="button"
              class="txn-submit twod-home-modal__confirm"
              @click="toGoToTwodPage(draw)"
            >
              {{
                $store.state.language === 'en'
                  ? 'Continue'
                  : 'ဆက်လုပ်မည်'
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import createDateWithTimeZone from "../../../../libs/createDateWithTimeZone"
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      twoDdata: {},
      isLive: false,
      twoDHistories: {},
      internetModern: [],
      livePollInterval: null,
      drawCheckInterval: null,
      threedData: {},
      twodOptions: [],
      draw: null,
      noticeText: null,
    };
  },
  computed: {
    lastNumber() {
      return (
        this.twoDHistories[0]?.evening_result
                || this.twoDHistories[0]?.mid_evening_result || this.twoDHistories[0]?.morning_result || this.twoDHistories[0]?.mid_morning_result
      );
    },
    lastUpdatedDraw() {
      if (
        this.twoDHistories.length > 0
                && this.twoDHistories[0]?.evening_result
      ) return '4:30 PM';
      if (
        this.twoDHistories.length > 0
                && this.twoDHistories[0]?.mid_evening_result
      ) return '2:45 PM';
      if (
        this.twoDHistories.length > 0
                && this.twoDHistories[0]?.morning_result
      ) return '12:00 AM';
      return '10:45 AM';
    },
    lastUpdatedDate() {
      return this.twoDHistories[0]?.draw_date;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    toGoToTwodPage(draw) {
        if(draw) {
            $('#timeLimitModal').modal('hide');
            this.$router.push(`/user/2d?draw=${draw}`);
        } else {
            $('#timeLimitModal').modal('show');
        }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },

   async drawOptionGenerator(){
        const currentTime = await createDateWithTimeZone();

        const morning = await createDateWithTimeZone();
        morning.setHours(11, 50);

        const evening = await createDateWithTimeZone();
        evening.setHours(15, 55);

        if(currentTime < morning){
            this.twodOptions = [
                {
                    data: 'm',
                    label: '12:01 PM',
                },
                {
                    data: 'f',
                    label: '4:30 PM',
                }
            ];
        } else if(currentTime < evening){
            this.twodOptions = [
                        {
                            data: 'f',
                            label: '4:30 PM',
                        }
                    ];
        }

        if(currentTime > evening){
            return this.noticeText = this.$store.state.language === "en" ? '2D is closed for Today.' : 'ယနေ့အတွက် နှစ်လုံးထီ ထိုးခြင်း ပိတ်ပါပြီ ။';
        }
    },
    async fetchTwoDliveresult() {
        const apiUrl = 'https://luke.2dboss.com/api/luke/twod-result-live';

        // Make a GET request using the fetch function
        fetch(apiUrl)
            .then(response => {
            // Check if the request was successful (status code 2xx)
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Parse the JSON response
            return response.json();
            })
            .then(data => {
            this.twoDdata = data.data || {}
            })
            .catch(error => {
            // Handle errors
            console.error('Error fetching data:', error);
            });
        // },
    },
    async fetchModernInternet() {
      try {
        const res = await axios.get('/modern-internet');
        this.internetModern = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
        if (this.isLive) {
            this.fetchTwoDliveresult();
            if (this.livePollInterval) clearInterval(this.livePollInterval);
            this.livePollInterval = setInterval(() => this.fetchTwoDliveresult(), 5000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    ready() {
    //   const channel = this.$pusher.subscribe('live-socket-channel');
    //   channel.bind('twod-live', async (data) => {
    //     this.twoDdata = data;
    //   });

      //   channel.bind('twod-isLive', async (data) => {
      //     this.isLive = data;
      //   });
    },

    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        this.twoDHistories = twoDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  destroyed() {
    // this.$pusher.unsubscribe('live-socket-channel');
    clearInterval(this.livePollInterval);
    clearInterval(this.drawCheckInterval);
  },
  unmount() {
    // this.$pusher.unsubscribe('live-socket-channel');
    clearInterval(this.livePollInterval);
    clearInterval(this.drawCheckInterval);
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }

    this.fetchTwoDdata();
    this.fetchTwoThreeDHistories();
    await this.drawOptionGenerator();
    if (this.drawCheckInterval) clearInterval(this.drawCheckInterval);
    this.drawCheckInterval = setInterval(async() => await this.drawOptionGenerator(), 30000);
  },
};
</script>
<style scoped>
/* Page shell — match Deposit / Withdraw */
.txn-page {
  min-height: 100vh;
  padding: 1rem 0.75rem 1.25rem;
  padding-bottom: calc(5.5rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.twod-home__inner {
  margin: 0 auto;
  max-width: 32rem;
}

.txn-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 1rem;
  overflow: hidden;
}

.txn-title {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.85rem 1rem 0.35rem;
  text-transform: uppercase;
}

.txn-section-title {
  color: #8b95a8;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.75rem 1rem 0;
  text-transform: uppercase;
}

.txn-body {
  padding: 0.5rem 1.125rem 1.35rem;
}

/* Quick actions */
.twod-home__quick {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.65rem;
  padding-top: 0.25rem;
}

.twod-quick {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: #252830;
  border: 1px solid transparent;
  border-radius: 12px;
  color: #c5cad6;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  min-height: 5.25rem;
  padding: 0.75rem 0.35rem;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.twod-quick:not(:disabled):active {
  filter: brightness(1.08);
}

.twod-quick:disabled {
  cursor: default;
  opacity: 0.55;
}

.twod-quick:not(:disabled):hover {
  border-color: rgba(92, 152, 255, 0.35);
  color: #e8eaef;
}

.twod-quick__icon {
  height: 28px;
  object-fit: contain;
  width: 28px;
}

.twod-quick__label {
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

/* Result card */
.twod-home__result-body {
  padding-top: 0.35rem;
}

.twod-live-wrap {
  text-align: center;
}

.twod-live-number {
  animation: twod-live-pulse 2s ease-in-out infinite;
  background: #252830;
  border-radius: 12px;
  color: #6a9fff;
  font-size: clamp(2.5rem, 12vw, 3.75rem);
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.1;
  padding: 1rem 0.75rem;
}

.twod-live-meta {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
}

.twod-live-meta__item {
  background: #252830;
  border-radius: 10px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 10rem;
  padding: 0.65rem 0.75rem;
}

.twod-live-meta__k {
  color: #8b95a8;
  font-size: 0.75rem;
  font-weight: 600;
}

.twod-live-meta__v {
  color: #f0f2f5;
  font-size: 1.25rem;
  font-weight: 700;
}

.twod-last-grid {
  align-items: stretch;
  display: flex;
  gap: 0;
  min-height: 8rem;
}

.twod-last-grid__num {
  align-items: center;
  background: #252830;
  border-radius: 12px 0 0 12px;
  color: #ff6b7a;
  display: flex;
  flex: 1;
  font-size: clamp(2.25rem, 10vw, 3rem);
  font-weight: 800;
  justify-content: center;
}

.twod-last-grid__placeholder {
  color: #5c6478;
  font-weight: 600;
}

.twod-last-grid__info {
  background: #252830;
  border-left: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0 12px 12px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1.1rem;
}

.twod-last-grid__hint {
  color: #6a9fff;
  font-size: 0.78rem;
  font-weight: 600;
  margin: 0 0 0.35rem;
}

.twod-last-grid__time,
.twod-last-grid__date {
  color: #c5cad6;
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0;
}

.twod-last-grid__date {
  color: #8b95a8;
  font-size: 0.8125rem;
  margin-top: 0.25rem;
}

@keyframes twod-live-pulse {
  0%,
  100% {
    color: #6a9fff;
  }
  50% {
    color: #b8d0ff;
  }
}

/* History table */
.twod-home__table-wrap {
  margin: 0 -0.25rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
}

.twod-history-table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.8125rem;
  width: 100%;
}

.twod-history-table th {
  background: #252830;
  color: #8b95a8;
  font-weight: 700;
  padding: 0.65rem 0.5rem;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.twod-history-table th:first-child {
  border-radius: 10px 0 0 0;
  padding-left: 0.75rem;
}

.twod-history-table th:last-child {
  border-radius: 0 10px 0 0;
  padding-right: 0.75rem;
}

.twod-history-table td {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  color: #e8eaef;
  font-weight: 600;
  padding: 0.7rem 0.5rem;
}

.twod-history-table td:first-child {
  padding-left: 0.75rem;
}

.twod-history-table td:last-child {
  padding-right: 0.75rem;
}

.twod-history-table tbody tr:hover td {
  background: rgba(92, 152, 255, 0.06);
}

/* Fixed bet bar */
.twod-home__bet-bar {
  bottom: 0;
  left: 0;
  padding: 0.65rem 0.75rem;
  padding-bottom: calc(0.65rem + 70px + env(safe-area-inset-bottom, 0px));
  pointer-events: none;
  position: fixed;
  right: 0;
  z-index: 100;
}

.twod-home__bet-btn {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  margin: 0 auto;
  max-width: 32rem;
  pointer-events: auto;
  width: 100%;
}

.txn-submit {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  font-weight: 600;
  justify-content: center;
  min-height: 3.35rem;
  padding: 0.8rem 1rem;
  transition: filter 0.15s ease;
}

.txn-submit:active {
  filter: brightness(1.05);
}

/* Modal — dark sheet */
::v-deep #timeLimitModal .modal-content.twod-home-modal {
  background: #1d1f26;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

.twod-home-modal__body {
  padding: 1.25rem 1.125rem 1.35rem;
}

.twod-home-modal__title {
  color: #e8eaef;
  font-size: 0.9375rem;
  font-weight: 700;
  margin: 0 0 1rem;
  text-align: center;
}

.twod-home-modal__notice {
  color: #c5cad6;
  font-size: 0.9375rem;
  line-height: 1.45;
  margin: 0 0 0.5rem;
  text-align: center;
}

.twod-draw-option {
  -webkit-tap-highlight-color: transparent;
  background: #252830;
  border: 1px solid transparent;
  border-radius: 12px;
  color: #e8eaef;
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.65rem;
  padding: 0.85rem 1rem;
  transition: background 0.15s ease, border-color 0.15s ease;
  width: 100%;
}

.twod-draw-option--active {
  background: rgba(92, 152, 255, 0.18);
  border-color: rgba(92, 152, 255, 0.55);
  color: #b8d0ff;
}

.twod-home-modal__confirm {
  margin-top: 0.5rem;
  width: 100%;
}

@media (max-width: 380px) {
  .twod-last-grid__num {
    font-size: 2rem;
  }

  .twod-live-number {
    font-size: 2.25rem;
  }
}
</style>
